/**
 * Neutral, branded full-viewport loading state.
 *
 * Rendered by ``AuthGate`` while the session is unresolved (the
 * ``/api/auth/me/`` probe is in flight) or while the global 401 handler
 * is navigating away. It deliberately mounts *nothing* of the protected
 * dashboard shell, so an unauthenticated visitor never sees an empty
 * dashboard flash before the redirect (design §1.5).
 *
 * Pure presentational primitive — no data fetching, no routing, no
 * business logic. The centered ``Spinner`` carries ``role="status"`` and
 * an accessible label, and the wrapper is marked ``aria-busy`` so
 * assistive tech announces the loading state.
 */

import { Spinner } from "@/components/ui/spinner"

export function FullScreenLoader() {
  return (
    <div
      aria-busy="true"
      data-testid="full-screen-loader"
      className="min-h-screen bg-background flex items-center justify-center"
    >
      <Spinner className="size-8 text-muted-foreground" />
    </div>
  )
}
